module.exports = [
    {
        name: 'CX-9',
        nicename: 'cx9',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885848&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037096/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885848&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX9_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885870&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037214/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885870&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX9_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885855&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885855&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037244/skeleton.gif'
            }
        }
    }
];


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/constants/luxury.js
// module id = 61
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14